import React from 'react';
import { Portal } from '@lt/components';
import styles from './subscriptionFormWrapper.module.css';

import SubscriptionForm from './SubscriptionForm';

import type { PropsFromRedux as ISubscriptionFormWrapper } from '.';

const SubscriptionFormWrapper = (props: ISubscriptionFormWrapper) => {
  const { isMobile, isOpen } = props;

  return (
    <>
      {isMobile && isOpen && (
        <Portal>
          <div className={styles.mobileWrapper}>
            <SubscriptionForm />
          </div>
        </Portal>
      )}

      {!isMobile && <SubscriptionForm />}
    </>
  );
};

export default SubscriptionFormWrapper;
